Controller = App.loadClass 'core::Angular/Controller'

class exports.EmailUnsubscribeController extends Controller
    constructor: ($scope, $http) ->
        $scope.save = () ->
            # Gather user's preferences
            postParams = emails: ({
                id: email.id
                receives_bulk: email.receives_bulk
            } for email in @emails)

            # Save
            $http.post 'backend/grower/unsubscribe/save-unsubscribe', postParams
            .then (response) =>
                @setAlert response.data.status
